"use client"
import { useEffect } from "react"

export default function ScrollProgress() {
  useEffect(() => {
    const bar = document.getElementById("ze-progress")
    if (!bar) return
    const update = () => {
      const { scrollTop, scrollHeight, clientHeight } = document.documentElement
      const pct = scrollHeight === clientHeight ? 0 : (scrollTop / (scrollHeight - clientHeight)) * 100
      bar.style.width = pct + "%"
    }
    window.addEventListener("scroll", update, { passive: true })
    return () => window.removeEventListener("scroll", update)
  }, [])
  return <div id="ze-progress" />
}
